export default __webpack_public_path__ + "static/media/mint-pass.646b6523.png";